import React from 'react';
import { ArrowRight } from 'lucide-react';
export function AboutStrip() {
  return <section id="about" className="py-12 md:py-20 bg-white" data-id="element-18">
      <div className="container mx-auto px-6 md:px-8" data-id="element-19">
        <div className="flex flex-col md:flex-row gap-12 lg:gap-20 items-center" data-id="element-20">
          {/* Left Image */}
          <div className="w-full md:w-1/2 relative" data-id="element-21">
            <div className="aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden relative shadow-soft" data-id="element-22">
              <div className="absolute inset-0 bg-brand-teal/10 z-10 mix-blend-multiply" data-id="element-23"></div>
              <img src="https://cdn.magicpatterns.com/uploads/e8omrYRj7K2s4fPGUSxnTM/pool-2.png" alt="Crystal clear residential pool" className="w-full h-full object-cover" data-id="element-24" />
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-light rounded-full -z-10 hidden md:block" data-id="element-25"></div>
          </div>

          {/* Right Content */}
          <div className="w-full md:w-1/2" data-id="element-26">
            <div className="text-brand-teal text-sm font-bold tracking-widest uppercase mb-4" data-id="element-27">
              About Royal Pool Cleaning
            </div>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-text mb-6" data-id="element-28">
              Luxury Care for Your Backyard Oasis.
            </h2>

            <div className="space-y-4 text-lg text-brand-muted mb-8" data-id="element-29">
              <p data-id="element-30">
                Royal Pool Cleaning is a premium pool maintenance company based
                in Madison, MS. We bring professional-grade expertise and a
                white-glove approach to every visit.
              </p>
              <p data-id="element-31">
                We specialize in residential pools, spas, and water features
                across the Madison area. Our commitment to excellence ensures
                your pool is always clean, balanced, and swim-ready.
              </p>
            </div>

            <div className="flex items-center gap-6 mb-8" data-id="element-32">
              <div className="w-16 h-16 rounded-full bg-brand-teal/10 flex items-center justify-center flex-shrink-0 text-brand-teal" data-id="element-33">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinelinejoin="round" data-id="element-34">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-35" />
                  <path d="m9 12 2 2 4-4" data-id="element-36" />
                </svg>
              </div>
              <div data-id="element-37">
                <div className="font-semibold text-brand-text" data-id="element-38">
                  Premium Quality Guarantee
                </div>
                <div className="text-sm text-brand-muted" data-id="element-39">
                  Trusted by Madison Homeowners
                </div>
              </div>
            </div>

            <a href="#contact" className="inline-flex items-center gap-2 text-brand-teal font-semibold hover:text-brand-teal/80 transition-colors group" data-id="element-40">
              Learn more about us
              <ArrowRight size={18} className="transform group-hover:translate-x-1 transition-transform" data-id="element-41" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}